import { Injectable } from '@angular/core';
import {  GenericConfig, RestUrlsConfig }  from '@signature-it/ngx-generic/config';
import { FccDTO, CngDataDTO, CngProductDTO }  from '@signature-it/ngx-generic/models';
import {throwError} from "rxjs";
import {tap} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class CngFormService {

	protected addUrl = `${this.restUrlsConf.appURL}/public/cng-product/add.json`;

	constructor(protected http: HttpClient,
				protected restUrlsConf: RestUrlsConfig) { }

	add(data: any, originReq) {
		return this.http.post(this.addUrl, JSON.stringify( {data , originReq}))
			.pipe(tap((res) => res, (error: any) => throwError(error)));
	}
}
